export var STOCK_DEFINITION_KEY = 'stockDefinition';
export var STOCK_VARIATION_KEY = 'stockVariation';
export var STOCK_SALE_KEY = 'stockSale';
export var STOCK_DEFAULT_KEY = 'stockDefault';
export var STOCK_CURRENCY_RISK_KEY = 'stockCurrencyRisk';
